export default __webpack_public_path__ + "static/adidas.url-1d7ef79a801dcd41d4600c17013da009.svg";